const resources = {
    pageTitle: 'Reset Password',
    pageDescription: 'To have your password reset, enter your email address below. We will then send an email containing a link to reset your password.',
    emailPlaceholder: 'Email address',
    emailRequired: 'Please enter your email address',
    sendResetLinkButton: 'Send Email',
    backToSignIn: 'Back to Sign In',
    stillHavingTrouble: 'Still having trouble?',
    unableToResetPassword: 'If you’re unable to reset your password, please call Customer Service at',
    phoneNumber: '(1-877-737-4672)',
    accessibility: 'Accessibility',
    resetPassword: 'Reset Password',
    fallbackErrorMsg: 'If you’re unable to reset your password, please call Customer Service at',
    confirmButton: 'OK',
    forAssistance: '| Deaf and Hard-of-Hearing/TTY see',
    emailSendFailed: 'We couldn\'t send a reset email. Check your email address or contact customer service.'
};

export default function getResource(label) {
    return resources[label];
}
